import Hero from './components/Hero';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import Projects from './components/Projects';
import WhatWeDo from './components/WhatWeDo';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import SeoHead from '@/components/SeoHead';
import { useTranslation } from 'react-i18next';

export default function HomePage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title={lang === 'ar' ? 'Debug - حلول تصحيح وتطوير البرمجيات والأنظمة المؤسسية' : 'Debug - Expert Debugging, Custom Development & Enterprise Platforms'}
        description={lang === 'ar'
          ? 'Debug تقدم خدمات تصحيح احترافية، تطوير مخصص، وحلول مؤسسية رائدة: 5vix لإدارة الجيم، Texio لمصانع النسيج، ووكيل ذكاء اصطناعي للواتساب. دعم 24/7.'
          : 'Debug provides professional software debugging, custom development, and flagship platforms: 5vix Gym System, Texio Textile ERP, and WhatsApp AI Agent. 24/7 expert support.'}
        keywords="debugging services, software development, 5vix gym, texio erp, whatsapp ai agent, bug fixing, performance optimization, cloud services egypt"
        canonical="https://debuging.com/"
        lang={lang}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                '@id': 'https://debuging.com/#organization',
                name: 'Debug',
                url: 'https://debuging.com/',
                logo: 'https://debuging.com/images/Enterprise-1.webp',
                description: 'Professional software debugging, custom development, AI automation, and industry ERP platforms.',
                telephone: '+20-109-9289-280',
                email: 'contact@debuging.com',
                address: {
                  '@type': 'PostalAddress',
                  addressCountry: 'EG',
                  addressLocality: 'Cairo',
                },
                sameAs: [
                  'https://5vix.com/',
                  'https://ai.5vix.com/',
                  'https://texio.debugin.com/',
                  'https://wyzon.debugin.com/',
                ],
              },
              {
                '@type': 'WebSite',
                '@id': 'https://debuging.com/#website',
                url: 'https://debuging.com/',
                name: 'Debug',
                publisher: {
                  '@id': 'https://debuging.com/#organization',
                },
              },
            ],
          }),
        }}
      />
      <header>
        <Navbar />
      </header>
      <main>
        <article id="home">
          <Hero />
        </article>
        <article id="services">
          <Services />
        </article>
        <article>
          <WhyChoose />
        </article>
        <article id="projects">
          <Projects />
        </article>
        <article id="what-we-do">
          <WhatWeDo />
        </article>
        <article id="faq">
          <FAQ />
        </article>
        <article id="contact">
          <CTA />
        </article>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}